// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let RivalIQ;
if (typeof window === 'undefined') {

    RivalIQ = {
        utils: {}
    };

} else {
    RivalIQ = window.RivalIQ;
    RivalIQ.module('utils', function () {});
}

(function () {

    'use strict';

    const companyEvents = {};

    // N.B. If you add/change anything here you must also update eventFeedServices.eventTypeIdToTable[].
    const eventType = companyEvents.eventType = {
        // webPageContentChange: 1,
        webPageTitleChange: 2,
        webPageMetaDescriptionChange: 3,
        webPageMetaKeywordsChange: 4,
        twitterDescriptionChange: 5,
        // twitterIconChange: 6,
        facebookDescriptionChange: 7,
        // facebookIconChange: 8,
        // linkedInDescriptionChange: 9,
        // linkedInIconChange: 10,
        // linkedInSpecialtiesChange: 11,
        landscapeBreakoutPost: 15,
        landscapeNotableMetricChange: 16, // deprecated for new events, retained for legacy events
        youTubeDescriptionChange: 17,
        // youTubeIconChange: 18,
        youTubeTitleChange: 19,
        youTubeKeywordsChange: 20,
        instagramDescriptionChange: 21,
        // instagramIconChange: 22,
        instagramNameChange: 23,
        instagramWebsiteChange: 24,
        twitterNameChange: 25,
        twitterHandleChange: 27,
        facebookUsernameChange: 28,
        // linkedInUsernameChange: 29,
        instagramUsernameChange: 30,
        // pinterestDescriptionChange: 31,
        // pinterestNameChange: 32,
        // pinterestBoardCreated: 33,
        // facebookAdsNewCampaign: 34,
        // facebookAdsNewBoostedPost: 35,
        facebookAdsUnderPerforming: 36,
        facebookAdsTopPerformer: 37,
        // facebookAdsFrequencyThreshold: 38,
        presenceDiscovered: 39,
        presenceGone: 40,
        engagementGrowth: 41,
        audienceGrowth: 42,
        // activityGrowth: 43,
        facebookLikelyBoostedPost: 44,
        // seoKeywordsImproved: 45,
        // seoKeywordsDeclined: 46,
        // seoKeywordsNew: 47,
        // googleAnalyticsSourceMediumGrowth: 48,
        // googleAnalyticsLandingPageGrowth: 49,
        tiktokNicknameChange: 50,
        tiktokDescriptionChange: 51,
        tiktokHandleChange: 52,
        listeningVolumeChange: 53
    };

    const seoEvents = [
        eventType.webPageTitleChange,
        eventType.webPageMetaDescriptionChange,
        eventType.webPageMetaKeywordsChange
    ];

    const socialEvents = [
        eventType.twitterDescriptionChange,
        eventType.twitterNameChange,
        eventType.twitterHandleChange,
        eventType.facebookDescriptionChange,
        eventType.facebookUsernameChange,
        eventType.youTubeDescriptionChange,
        eventType.youTubeTitleChange,
        eventType.youTubeKeywordsChange,
        eventType.instagramDescriptionChange,
        eventType.instagramNameChange,
        eventType.instagramUsernameChange,
        eventType.tiktokNicknameChange,
        eventType.tiktokDescriptionChange,
        eventType.tiktokHandleChange
    ];

    const presenceChangedEvents = [
        eventType.presenceDiscovered,
        eventType.presenceGone
    ];

    companyEvents.eventClass = {
        all: {
            id: 0,
            members: null
        }, // meta-class
        webPageSeo: {
            id: 2,
            members: seoEvents
        },
        social: {
            id: 3,
            members: socialEvents
        },
        landscape: {
            id: 4,
            members: [
                eventType.landscapeBreakoutPost,
                eventType.landscapeNotableMetricChange,
                eventType.engagementGrowth,
                eventType.audienceGrowth
            ]
        },
        alertsAll: {
            id: 5,
            members: null
        }, // meta-class
        alertsWebPageSeo: {
            id: 6,
            members: [
                eventType.webPageTitleChange,
                eventType.webPageMetaDescriptionChange
            ]
        },
        alertsSocial: {
            id: 7,
            members: socialEvents
        },
        alertsLandscape: {
            id: 8,
            members: [
                eventType.landscapeBreakoutPost,
                eventType.landscapeNotableMetricChange,
                eventType.engagementGrowth,
                eventType.audienceGrowth
            ]
        },
        alertsFacebookAds: {
            id: 9,
            members: [
                eventType.facebookAdsUnderPerforming,
                eventType.facebookAdsTopPerformer
            ]
        },
        alertsAllEmail: {
            id: 10,
            members: null
        }, // meta-class (like alertsAll but without facebook ad alerts)
        alertsLandscapeBreakoutPost: {
            id: 13,
            members: [
                eventType.landscapeBreakoutPost
            ]
        },
        presenceChange: {
            id: 14,
            members: presenceChangedEvents
        },
        alertsPresenceChange: {
            id: 15,
            members: presenceChangedEvents
        },
        engagementGrowth: {
            id: 16,
            members: [
                eventType.landscapeNotableMetricChange,
                eventType.engagementGrowth
            ]
        },
        audienceGrowth: {
            id: 17,
            members: [
                eventType.landscapeNotableMetricChange,
                eventType.audienceGrowth
            ]
        },
        alertsLikelyBoostedPosts: {
            id: 18,
            members: [
                eventType.facebookLikelyBoostedPost
            ]
        },
        alertsInstagramLinkedSite: {
            id: 21,
            members: [
                eventType.instagramWebsiteChange
            ]
        },
        alertsListening: {
            id: 22,
            members: [
                eventType.listeningVolumeChange
            ]
        }
    };

    // NOTE export the results, for both server and client
    if (typeof window === 'undefined') {
        module.exports = companyEvents;
    } else {
        RivalIQ.utils.companyEvents = companyEvents;
    }

})();
